var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"color":"success","x-large":"","block":"","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm._f("lang")('Pagar con Tarjeta'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }